<template>
  <div v-if="loaded">
    <nav class="mx-4 border-b border-gray-dark">
        <h2 class="font-bold text-xl px-4 py-4">Teams</h2>
    </nav>

    <div v-if="teams.length > 0">
        <div class="p-4 text-right">
            <a href @click.prevent="createNewTeam" class="py-2 px-4 rounded-md bg-primary text-white font-bold">Create new team</a>
        </div>
        <table class="w-full table-fixed">
            <thead>
                <tr class="border border-gray-light bg-gray-light">
                    <th class="hidden md:table-cell w-1/4 uppercase text-xs text-left px-8 py-3">Team</th>
                    <th class="w-2/4 pl-2 md:pl-0 uppercase text-xs text-left py-3">Created On</th>
                    <th class="w-1/4 pr-2 md:px-8 uppercase text-xs text-right py-3">Members</th>
                </tr>
            </thead>
            <tbody>
                <tr class="border border-b border-gray-light" v-for="team in teams" :key="team.id">
                    <td class="hidden md:table-cell px-8 py-2 font-bold"><a :href="team.url" class="text-primary underline">{{ team.name }}</a></td>
                    <td class="pl-2 md:pl-0 py-2 flex items-center">{{ team.created_on }}</td>
                    <td class="pr-2 md:px-8 py-2 text-right">{{ team.users_in_team }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div v-else class="my-4 pb-16 text-center">
        <img src="/images/empty-state.svg" alt="No Teams Found" class="mx-auto">
        <p class="mx-8 xl:mx-64 my-16 font-bold text-primary">
            You haven't created any teams yet.
        </p>
        <a href @click.prevent="createNewTeam" class="py-2 px-4 rounded-md bg-primary text-white font-bold">Create new team</a>
    </div>
</div>
<div v-else>
    <loading />
</div>
</template>

<script>
import CreateTeamModal from './CreateTeamModal.vue';

export default {
    data() {
        return {
            loaded: false,
            teams : [],
        }
    },
    mounted() {
        this.loadTeams();
    },
    methods: {
        loadTeams() {
            axios.get('/api/teams')
                .then(response => {
                    this.teams  = response.data.data;
                    this.loaded = true;
                })
                .catch(console.log);
        },
        createNewTeam() {
            Modal.show(CreateTeamModal)
                .then(team => {
                    window.location = `/teams/${team.id}`
                })
                .catch(console.log);
        }
    }
}
</script>